import { DefaultGameState, GameState } from "@shared/types";
import { css } from "../helpers/webComponents";
import { GameRouteService } from "../services/GameRouteService";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
import { SuspectListService } from "../services/SuspectListService";
const styles: string = css`
    .list {
        border: solid 2px #ffffff99;
        background-color: #4b628b81;
        border-radius: 5px;
        padding: 6px;
        font-size: 24px;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .list p:hover {
        color: #ffffff99;
        cursor: pointer;
    }
`;

export class SuspectListComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /** Current game state */
    private _currentGameState?: DefaultGameState;

    private _suspectListService: SuspectListService = new SuspectListService();

    public constructor() {
        super();
    }

    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        this.updateGameState(state);
    }

    /**
         * Update the canvas to the provided game state
         *
         * @param state Game state to update the canvas to
         */
    private updateGameState(state: GameState): void {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        // Reset the component
        this._currentGameState = state;
    }

    public async connectedCallback(): Promise<void> {
        this.attachShadow({ mode: "open" });
        await this.refreshGameState();
        this.render();
    }

    public render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>
            <div class="list">
            </div>
        `;
        const suspectNames: string[] = this._currentGameState?.suspectList ? this._currentGameState.suspectList : [""];
        const listElement: HTMLElement | null = this.shadowRoot.querySelector(".list");

        if (listElement) {
            // Clear any existing suspect names
            listElement.innerHTML = "";

            // Append each suspect name as a <p> element
            suspectNames.forEach(name => {
                const suspectIndex: number = suspectNames.indexOf(name);
                const suspectElement: HTMLElement = document.createElement("p");
                const strikeArray: boolean[] = this._currentGameState?.strikeArray as boolean[];

                suspectElement.textContent = name;
                if (strikeArray[suspectIndex]) {
                    suspectElement.style.color = "#ffffff99";
                    suspectElement.style.textDecoration = "line-through";
                }
                listElement.appendChild(suspectElement);

                suspectElement.addEventListener("click", async () => {
                    console.log(this._currentGameState?.strikeArray[suspectIndex]);
                    if (!this._currentGameState?.strikeArray) return;
                    if (this._currentGameState.strikeArray[suspectIndex]) {
                        suspectElement.style.color = "white";
                        suspectElement.style.textDecoration = "none";
                        await this._suspectListService.updateStrikeArray(suspectIndex, false);
                        strikeArray[suspectIndex] = false;
                    }
                    else {
                        suspectElement.style.color = "#ffffff99";
                        suspectElement.style.textDecoration = "line-through";
                        await this._suspectListService.updateStrikeArray(suspectIndex, true);
                        strikeArray[suspectIndex] = true;
                    }
                });
            });
        }
    }
}
